import { useEffect, useState } from 'react';
import { useLocalstorageState } from 'rooks';

import { getSystemTheme } from './_helpers';

const defaultTheme = 'light';

export const useTheme = () => {
  const [theme, setTheme] = useLocalstorageState('theme', defaultTheme);
  // Resolved on the first render rather than in the effect below: consumers that hand
  // the theme to a surface they do not style themselves (the Univer grid, sonner, the
  // maps) read it as they mount, and a value that starts at 'light' and corrects itself
  // an effect later makes those mount light and then flip.
  const [resolvedTheme, setResolvedTheme] = useState(() => (theme === 'system' ? getSystemTheme() : theme));

  useEffect(() => {
    if (theme === 'system') {
      setResolvedTheme(getSystemTheme());

      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => setResolvedTheme(getSystemTheme());

      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else {
      setResolvedTheme(theme);
    }
  }, [theme]);

  useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      root.classList.add(getSystemTheme());
      return;
    }

    root.classList.add(theme);
  }, [theme]);

  return {
    theme,
    resolvedTheme,
    setTheme
  };
};
